import { createI18n } from 'vue-i18n'
import store from '../state/store'
import axios from '../api/axios';
import qs from "qs";

const locked = new Set();

const i18n = createI18n({
    locale: 'hu',
    // fallbackLocale: 'en',
    globalInjection: true,
    missing: async (locale, key) => {
        if (locked.has('run')) {
            return;
        }

        locked.add('run');

        const data = {translationKey: key};
        const translation = await axios.get(`intl/translation/${locale}`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  });

        locked.delete('run');

        const value = translation?.data;

        if (value) {
            i18n.global.mergeLocaleMessage(locale, value);
        }

        return value?.[key] || key; // vagy: return 'N/A', null, stb.
    }
})

store.$t = i18n.global.t
store.$rt = i18n.global.rt
store.$tc = i18n.global.tc
store.$te = i18n.global.te
store.$tm = i18n.global.tm
store.$d = i18n.global.d
store.$n = i18n.global.n

export default i18n
